import bind from 'bind-decorator';
import { action, observable } from 'mobx';
import { en, es } from '../i18n/dictionaries';
import { Translator } from '../i18n/translator';
import { Booking } from '../models/booking';
import { Passenger } from '../models/passenger';
import { reportError } from '../telemetry';

// tslint:disable:readonly-keyword

export class AppStore {
  public pnr: string | null = null;
  public lastName: string | null = null;
  @observable public booking: Booking;
  public culture: string;

  constructor(culture: string = 'es-MX') {
    this.culture = culture;
  }

  public get translator(): Translator {
    if (this.culture === 'en-US') {
      return new Translator(en);
    } else if (this.culture === 'es-MX') {
      return new Translator(es);
    } else {
      reportError(new Error('Unexpected culture'), { tags: { culture: this.culture } });
      return new Translator(es);
    }
  }

  @bind
  @action
  public storeSuccessfulLogin(pnr: string, lastName: string, booking: Booking) {
    this.pnr = pnr;
    this.lastName = lastName;
    this.booking = booking;
  }

  @action
  public updatePassenger(passenger: Passenger) {
    const index = this.booking.passengers.findIndex((p) => p.id === passenger.id);
    const passengers = this.booking.passengers.slice();
    passengers[index] = passenger;
    this.booking = { ...this.booking, passengers };
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/stores/app-store.ts